import { PromotionItem } from '../app/models';

export const getPriceWithDiscount = (promotionItem: PromotionItem): number => +promotionItem.product.price * (1 - +promotionItem.discount);

export const getPriceWithDiscountOnePay = (promotionItem: PromotionItem): number => getPriceWithDiscount(promotionItem) * (1 - +promotionItem.onePaymentDiscount);
